import {useState, useEffect} from 'react'
import Select from 'react-select';
import { Link } from 'react-router-dom'

const EditUserProfile = ({language, editor, profiles, setUpdatedEditor, showProfileLink}) => {
    const [editorId, setEditorId] = useState()
    const [editorName, setEditorName] = useState()
    const [editorEmail, setEditorEmail] = useState()
    const [editorPwd, setEditorPwd] = useState('')
    const [editorPwd2, setEditorPwd2] = useState('')
    const [profileId, setProfileId] = useState()
    const [selectedProfile, setSelectedProfile] = useState()
    const [filter, setFilter] = useState()
    const [passwordChange, setPasswordChange] = useState(false)
    const [editorChanged, setEditorChanged] = useState(false)
    const [passwordError, setPasswordError] = useState(false)
    const [editorUpdated, setEditorUpdated] = useState(false)
    const [strengthBadge, setStrengthBadge] = useState('')


    useEffect(() => {
        setTimeout(() => {
            setEditorUpdated(false)
        }, 2000);

    },[editorUpdated])

    useEffect(() => {
        const getEditorData = async () => {
            setEditorName(editor.editorName)
            setEditorEmail(editor.editorEmail)
            setProfileId(editor.profileId)
            setEditorId(editor.id)
            setFilter(profiles.map((profile) => {
                return {value: profile.id, label: profile.profileName};
            }))
            profiles.map((profile) => {
                if(profile.id === editor.profileId){ 
                    console.log(filter)
                    console.log(`Option selected:`, {value: profile.id, label: profile.profileName});
                    setSelectedProfile({value: profile.id, label: profile.profileName})
                    return {value: profile.id, label: profile.profileName}
                }
            })
        }
        getEditorData()

    },[editor, profiles])

    const handleChangeProfile = (selectedOption) => {
        setProfileId( selectedOption.value )
        setSelectedProfile(selectedOption)
        setEditorChanged(true)
    }

    const handleNameChanged = e => {
        setEditorName(e.target.value)
        setEditorChanged(true)
    }
    const handleEmailChanged = e => {
        setEditorEmail(e.target.value)
        setEditorChanged(true)
    }

    const handlePasswordChanged = e => {
        setEditorPwd(e.target.value)
        validatePwd(e)
    }
    const handlePassword2Changed = e => {
        setEditorPwd2(e.target.value)
        setPasswordError(editorPwd !== e.target.value)
    }

    
    const validatePwd = e=>{
        setEditorPwd(e.target.value)
        let timeout;
        let password = e.target.value
        let strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{10,})')
        let mediumPassword = new RegExp('((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{10,}))')

        if(strongPassword.test(password)) {
            setStrengthBadge('Strong')
            setEditorChanged(true)
        } else if(mediumPassword.test(password)) {
            setStrengthBadge('Medium')
            setEditorChanged(true)
        } else {
            setStrengthBadge('Weak')
            setEditorChanged(false)
        }
        if(password === ''){
            setStrengthBadge('');
            setEditorChanged(false)
        }
    }

    const updateEditor = async () => {
        let error = false
        if(editorName === ""){error = true}
        if(editorEmail === ""){error = true}
        if(passwordError){error = true}
        if(strengthBadge === 'Weak'){error = true}
        if(!error){
            var graphql = JSON.stringify({
                query: `mutation($id: Long, $editorName: String, $editorEmail: String, $editorPwd: String, $profileId: Long) {
                            updateEditor(id:$id, editorName: $editorName, editorEmail: $editorEmail, editorPwd: $editorPwd, profileId: $profileId) {
                                id
                                editorName
                                editorEmail
                                editorPwd
                                profileId
                            }
                        }`,
                variables: {
                    "id": editorId
                    , "editorName": editorName
                    , "editorEmail": editorEmail
                    , "editorPwd": editorPwd
                    , "profileId": profileId
                }
            })
            const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
                method:'POST',
                headers:{
                    'Authorization':'Basic ' + global.config.Editor.authToken
                    ,'Content-Type': 'application/json'
                },
                body: graphql
            })
            .then(response => response.text())
            .then(result => {
                setEditorUpdated(true)
                setEditorPwd()
                setEditorPwd2()
                setPasswordChange(false)
                const resData = JSON.parse(result).data
                setUpdatedEditor(resData.updateEditor)
                return resData

            })
            .catch(error => console.log('error', error))
            const data = await res
            return data
        }
    }

    return (
        <div>
            {(editorUpdated) && 
            <div className={`cc-info-box saved`}>
                <b>{language.value === "DA" ? "Bruger gemt" : "User saved"}</b>
            </div>
            }
            <label className="input_label">
                <span>{language.value === "DA" ? "Navn" : "Name"}</span>
                <input type="text" required onChange={handleNameChanged} value={editorName} autoComplete="off"/>
            </label>
            <label className="input_label">
                <span>Email</span>
                <input type="text" required onChange={handleEmailChanged} value={editorEmail} autoComplete="off"/>
            </label>
            {(!passwordChange) && <span className="txt-link" onClick={e => setPasswordChange(true)}>{language.value === "DA" ? "Skift adgangskode" : "Change password"}</span> }
            {
                (passwordChange) && <>
            <label className="input_label">
                <span>{language.value === "DA" ? "Adgangskode" : "Password"}</span>
                <input type="password" required onChange={handlePasswordChanged} value={editorPwd} autoComplete="off"/>
            </label>
                    {(strengthBadge) && 
                    <label className="input_label">
                        {(strengthBadge === 'Weak') && <span className="cc_user_password_strength weak">{language.value === 'DA' ? 'Svag adgangskode' : 'Weak Password'}</span>}
                        {(strengthBadge === 'Medium') && <span className="cc_user_password_strength medium">{language.value === 'DA' ? 'Medium Adgangskode' : 'Medium Password'}</span>}
                        {(strengthBadge === 'Strong') && <span className="cc_user_password_strength strong">{language.value === 'DA' ? 'Stærk Adgangskode' : 'Strong Password'}</span>}
                    </label>
                    }
            <label className="input_label">
                <span>{language.value === "DA" ? "Gentag adgangskode" : "Confirm password"}</span>
                <input type="password" required onChange={handlePassword2Changed} value={editorPwd2} autoComplete="off"/>
                {(passwordError) && <i className="sprite-icon icon-close"></i>}
            </label>
            <div className="cc_password_requirements">
            {(language.value === 'DA') &&
                <>
                    <b>
                        Krav til adgangskoden:
                    </b>
                    <ul>
                        <li>mindst et lille bogstav (a-z)</li>
                        <li>mindst et stort bogstav (A-Z)</li>
                        <li>mindst et ciffer (0-9)</li>
                        <li>mindst et specialtegn (?!#&%)</li>
                        <li>og skal være på mindst otte tegn</li>
                    </ul>
                </>
                }
                
                {(language.value !== 'DA') &&
                <>
                    <b>
                        Password requirements:
                    </b>
                    <ul>
                        <li>at least one lowercase letter (a-z)</li>
                        <li>at least one uppercase letter (A-Z)</li>
                        <li>at least one digit (0-9)</li>
                        <li>at least one special character (?! # &%)</li>
                        <li>and must be at least eight characters long</li>
                    </ul>
                </>
                }
                </div>
            </>
            }
            <label className="input_label">
                <span>{language.value === "DA" ? "Profil" : "Profile"}</span>
                <Select 
					className="profileSelect"
					classNamePrefix="profileSelect"
					options={filter} 
					onChange={handleChangeProfile} 
					value={selectedProfile}
					/>
            </label>
            {(showProfileLink && selectedProfile) && <Link to={`/control/profiles/${selectedProfile.value}`}><span className="txt-link">{language.value === "DA" ? "Gå til profil" : "Go to profile"}:</span> {selectedProfile.label}</Link>}

            {
                (editorChanged && !passwordError) && <>
                    <div className="align_right">
                        <button className="cc-btn blue-gradient" onClick={updateEditor}>{language.value === 'DA' ? 'GEM ÆNDRINGER' : 'SAVE CHANGES'}</button>
                    </div>
                </>
            }
        </div>
    )
}

export default EditUserProfile
